import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { InterviewDecline } = await import('./index');
    return {
        Component: InterviewDecline,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
